export default "__VITE_ASSET__Dyf$Xd6V__"